import { RouterProvider } from 'react-router-dom';
import { StaffProfileProvider } from './profile-context.tsx';
import { router } from './router.tsx';

export function App(): JSX.Element {
  return (
    <StaffProfileProvider>
      <RouterProvider router={router} />
    </StaffProfileProvider>
  );
}
